"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLiveRegion = void 0;
var _react = require("react");
const useLiveRegion = function () {
  let {
    "aria-atomic": ariaAtomic = true,
    isDisabled = false,
    "aria-live": ariaLive = "polite"
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [children, setChildren] = (0, _react.useState)("");
  return {
    clear: (0, _react.useCallback)(() => setChildren(""), []),
    speak: setChildren,
    getLiveRegionProps: function () {
      let overrideProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        role: "status",
        "aria-live": isDisabled ? "off" : ariaLive,
        "aria-atomic": ariaAtomic,
        ...overrideProps,
        children: children
      };
    }
  };
};
exports.useLiveRegion = useLiveRegion;
//# sourceMappingURL=useLiveRegion.js.map